const React = require('react');
const withReDelay = require('mn-utils/withReDelay');
const {paramStore} = require('../../../../stores');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonUp = require('../../../dumb/Button/Up');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');

const {IntervalFilterAdmin, getFilterParams} = require('../../../dumb/IntervalFilterCustom');

const {lifeFlowFilter} = require('./constants/lifeflowStatuses');
const {userRolesFilter} = require('./constants/userRoles');

const TableItem = require('./components/TableItem');

const filter$ = paramStore('filter', {});

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
  },
  rowHeight: 70,
  request: require('../../../../api/admin/accounts').apiAdminAccountsList,
  getParams: getFilterParams('lifeflow', 'account_type'),
  wrapper(render, setState, self) {
    function handleChangeFilter(filter) {
      const update = withReDelay(self.update, 1000);
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    return (state) => {
      const filter = state.filter;

      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Accounts</CaptionA>
          </HeaderA>
          <IntervalFilterAdmin
            className="mt16"
            data={filter}
            search={{
              className: 'w260',
              placeholder: 'Search by Email'
            }}
            onChange={handleChangeFilter}
            selectFilters={[userRolesFilter, lifeFlowFilter]}
            hideTimeInterval
          />
          <div className="rlv h100vh-330 mh-45">
            <div className="ovxA abs s ph45">
              <div className="wmin1380 rlv h">
                <div>
                  <RowB>
                    <ColB className="wmin170 fx1">ID</ColB>
                    <ColB className="wmin150 fx1">Login</ColB>
                    <ColB className="wmin120 fx1">Name</ColB>
                    <ColB className="wmin120 fx1">Role</ColB>
                    <ColB className="wmin150 fx1">Lifeflow</ColB>
                    <ColB className="wmin150 fx1">Limits</ColB>
                    <ColB className="wmin110">Updated At</ColB>
                    <ColB className="w90">Blocked</ColB>
                    <ColB className="wmin210">BPay ID</ColB>
                    <ColB className="wmin155" />
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(TableItem)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
